import { hslInterpolator } from './hslInterpolator';


export const generateSchemeHsl = (numColors) => (
  Array.from({ length: numColors }, (_, i) => hslInterpolator(i / (numColors - 1)))
);
